import React from 'react';
import Logo from './Logo';

const Header = () => {
  return (
    <header className="chat-header">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', marginBottom: '8px' }}>
        <Logo size="medium" variant="light" />
      </div>
      <p>Ask me anything about TapMyBack's employee recognition platform</p>
    </header>
  );
};

export default Header;

